import * as React from 'react';
/**
 * Context which holds the navigation helpers of the parent navigator.
 * Navigators should use this context in their view component.
 */
export const NavigationHelpersContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=NavigationHelpersContext.js.map